import React from 'react';
import styles from './styles.module.less';

export function LtIcon({ className }) {
  return (
    <svg
      x="0px"
      y="0px"
      viewBox="0 0 33.3 20.9"
      className={className}
    >
      <rect x="0" y="0.1" className={styles.st0} width="33.3" height="7.1" />
      <rect x="0" y="7" className={styles.st1} width="33.3" height="7.1" />
      <rect x="0" y="13.9" className={styles.st2} width="33.3" height="7.1" />
    </svg>
  );
}
